function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#219653"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0518 15.3852L7.8918 13.2252C7.61028 12.9437 7.61028 12.4887 7.8918 12.2071C8.17332 11.9256 8.62836 11.9256 8.90988 12.2071L10.5198 13.8171L15.0544 8.64819C15.3136 8.34579 15.7679 8.31123 16.0688 8.56971C16.3712 8.82891 16.4065 9.28251 16.1473 9.58419L11.1073 15.3442C10.977 15.4968 10.7884 15.5875 10.5882 15.5955C10.37 15.5962 10.1864 15.5206 10.0518 15.3852Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 8,
  width: 10,
  height: 8
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0518 15.3852L7.8918 13.2252C7.61028 12.9437 7.61028 12.4887 7.8918 12.2071C8.17332 11.9256 8.62836 11.9256 8.90988 12.2071L10.5198 13.8171L15.0544 8.64819C15.3136 8.34579 15.7679 8.31123 16.0688 8.56971C16.3712 8.82891 16.4065 9.28251 16.1473 9.58419L11.1073 15.3442C10.977 15.4968 10.7884 15.5875 10.5882 15.5955C10.37 15.5962 10.1864 15.5206 10.0518 15.3852Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgApprovedCheck = function SvgApprovedCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApprovedCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approved-check.4b300194.svg";
export { ForwardRef as ReactComponent };